var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYellowBotX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 107,
    viewBox: "0 0 113 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 82.8384L79 42.8384",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 85L56 51",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48L88 15",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26L101 11",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55L12 15",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59L25 37",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25L94 88",
    stroke: "#FDDC2D",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 95,
    r: 10,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 36,
    r: 10,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 93,
    r: 10,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 14,
    r: 10,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 7.5,
    r: 5.5,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 9.5,
    r: 5.5,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 5.5,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 34.5,
    r: 5.5,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 87.5,
    r: 5.5,
    stroke: "#FDDC2D",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBotX);
export default __webpack_public_path__ + "static/media/yellow-bot-x.0250b36d287face264905c06f2fbc909.svg";
export { ForwardRef as ReactComponent };